// extracted by mini-css-extract-plugin
export default {"GreetingsWrapper":"DashboardView_GreetingsWrapper__mZ6hR","TextWrapper":"DashboardView_TextWrapper__P0sJE","Title":"DashboardView_Title__OcUW8","Info":"DashboardView_Info__njrgF"};